import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export type PriceSortOrder = 'ASC' | 'DESC' | null;

export interface PriceRangeFilter {
  fromNumber?: number | null;
  toNumber?: number | null;
}

@Injectable({
  providedIn: 'root'
})
export class DashboardFilterService {
  private readonly sortOrderSubject = new BehaviorSubject<PriceSortOrder>(null);
  private readonly keywordSubject = new BehaviorSubject<string>('');
  private readonly priceRangeSubject = new BehaviorSubject<PriceRangeFilter | null>(null);

  get sortOrder$(): Observable<PriceSortOrder> {
    return this.sortOrderSubject.asObservable();
  }

  get keyword$(): Observable<string> {
    return this.keywordSubject.asObservable();
  }

  get priceRange$(): Observable<PriceRangeFilter | null> {
    return this.priceRangeSubject.asObservable();
  }

  get currentSortOrder(): PriceSortOrder {
    return this.sortOrderSubject.value;
  }

  setSortOrder(order: PriceSortOrder): void {
    this.sortOrderSubject.next(order);
  }

  setKeyword(keyword: string): void {
    this.keywordSubject.next(keyword || '');
  }

  setPriceRange(range: PriceRangeFilter | null): void {
    this.priceRangeSubject.next(range);
  }
}
